import actions from './actions';
import getters from './getters';
import mutations from './mutations';
import formdata from './formdata'

const state = {
   
    data: {
        name:'',                       
    },

    tagcategories:[],                
    
};

export default {
  namespaced: true,
  modules: {
        formdata: formdata,
        
    },
  state,
  actions,
  getters,
  mutations,
};